import { MORTGAGE_PROMO_TYPES } from '../../constants/promos';
import { IPromo } from '../../types/newbuilding/promos';
import { IApplicationState } from '../../types/redux';
import { getPromos } from '../newbuilding';

export const selectNewbuildingPromos = (state: IApplicationState): IPromo[] => {
  const promos = getPromos(state);

  if (!promos.length) {
    return [];
  }

  return promos.filter(promo => !MORTGAGE_PROMO_TYPES.includes(promo.promoType));
};
